import { render, staticRenderFns } from "./PrinterSettingsPage.vue?vue&type=template&id=dffb8338&scoped=true&"
import script from "./PrinterSettingsPage.vue?vue&type=script&lang=js&"
export * from "./PrinterSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./PrinterSettingsPage.vue?vue&type=style&index=0&id=dffb8338&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffb8338",
  null
  
)

export default component.exports